var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wang-editor-control"},[(_vm.readonly)?_c('div',{staticClass:"wang-editor-readonly",domProps:{"innerHTML":_vm._s(_vm.currentValue)}}):_c('div',{staticClass:"wang-editor-instance",attrs:{"id":_vm.editorId}})])}
var staticRenderFns = []

export { render, staticRenderFns }